import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { CASHBACK_STATUS } from '@woovi/shared';
import { Ribbon } from '@woovi/ui';
import { convertToCurrency } from '@woovi/utils';

import type { PaymentLinkActiveEarnCashback_charge$key } from './__generated__/PaymentLinkActiveEarnCashback_charge.graphql.ts';

import type { ReactNode } from 'react';

type PaymentLinkActiveEarnCashbackProps = {
  charge: PaymentLinkActiveEarnCashback_charge$key;
};
const PaymentLinkActiveEarnCashback = (
  props: PaymentLinkActiveEarnCashbackProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const charge = useFragment<PaymentLinkActiveEarnCashback_charge$key>(
    graphql`
      fragment PaymentLinkActiveEarnCashback_charge on Charge {
        cashback {
          percentage
          value
          status
        }
      }
    `,
    props.charge,
  );

  if (!charge?.cashback) {
    return null;
  }

  if (charge.cashback?.status !== CASHBACK_STATUS.PENDING) {
    return null;
  }

  const earnCashbackValue = convertToCurrency(charge.cashback.value / 100);

  return (
    <Ribbon>
      <Typography>🤑</Typography>
      <Typography color={theme.palette.tertiary.main} sx={{ fontSize: '16px' }}>
        <b>{earnCashbackValue}</b> {t('cashback on time!')}
      </Typography>
    </Ribbon>
  );
};

export default PaymentLinkActiveEarnCashback;
